export default __webpack_public_path__ + "static/media/image3.1bc8e42d.png";